export default "__VITE_ASSET__DgvMqCl1__"